import * as Constant from '../../constant';
import * as Action from '../action';

const initialState = {
  filters: {
    [Constant.TABLE_FIELD_ORDER_DETAIL_CONTAINER_NO]: '',
    [Constant.TABLE_FIELD_ORDER_DETAIL_SO_NO]: '',
    [Constant.TABLE_FIELD_ORDER_DETAIL_BL_NO]: '',
    [Constant.TABLE_FIELD_ORDER_DETAIL_CONTAINER_NO_OUT]: '',
    [Constant.TABLE_FIELD_ORDER_DETAIL_SO_NO_OUT]: '',
    [Constant.TABLE_FIELD_ORDER_DETAIL_STATUS]: '',
  },
  sortField: '',
  sortDirection: '',
  activePage: 1,
  pageSize: 5,
  selectedTab: Constant.ADMIN_TAB_ORDER_ASSIGN_TRUCK,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Action.SET_ORDER_DETAIL_VENDOR_FILTER: {
      return {
        ...state,
        filters: {
          ...state.filters,
          ...action.value,
        },
      };
    }
    case Action.SET_ORDER_DETAIL_VENDOR_PAGING: {
      return { ...state, ...action.value };
    }
    case Action.SET_ORDER_DETAIL_VENDOR_SORT: {
      return { ...state, sortField: action.sortField, sortDirection: action.sortDirection };
    }
    case Action.SET_ORDER_DETAIL_VENDOR_SELECTED_TAB: {
      return { ...state, selectedTab: action.value };
    }
    default: {
      return state;
    }
  }
};
